import Slider from './View';

export default Slider;
